import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/uiconfig';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from 'gw-digital-auth-react';
import { ApplicationHeader, SubApplicationHeader } from '@jutro/router';
import { DropdownMenuLink } from '@jutro/components';
import metadata from './PageHeaderComponent.metadata.json5';
import pageHeaderStyles from './PageHeaderComponent.module.scss';
import messages from './PageHeaderComponent.messages';

function PageHeaderComponent(props) {
    const auth = useAuthentication();
    const { routes } = props;
    const translator = useTranslator();
    const { env } = appConfig;
    const getAvatarLinks = useCallback(() => {
    const isWebAdmin = (_.isUndefined(auth.authUserData)) ? false : auth.authUserData.isWebAdmin;
    const isDirectBill = (_.isUndefined(auth.authUserData)) ? false : auth.authUserData.isDirectBill;

    const links = [];

        // Only show Edit Profile and Change Password links if user is not a WebAdmin
        if (!isWebAdmin) {
            links.push(
                <DropdownMenuLink to="/editprofile" key="1">{translator(messages.editProfile)}</DropdownMenuLink>,
                <DropdownMenuLink to="/changepassword" key="2">{translator(messages.changePassword)}</DropdownMenuLink>
            );
        }
        if (isDirectBill) {
            links.push([
                <DropdownMenuLink to="/ri-notifications" key="3">
                    {translator(messages.myNotification)}
                </DropdownMenuLink>
            ]);
        }
        // <DropdownMenuLink to="/userprofile">{translator(messages.account)}</DropdownMenuLink>,
        // <DropdownMenuLink to="/faq">{translator(messages.faq)}</DropdownMenuLink>
        // when using jutroAuthContext, jutro application header add the logout link by default
        // avoiding custom logout for gwcp and follow jutro
        if (!auth.useJutroAuthContext) {
            links.push([
                <DropdownMenuLink onClick={auth.logout} key="4">
                    {translator(messages.logout)}
                </DropdownMenuLink>
            ]);
        }
        return links;
    }, [translator, auth]);

    const getLogoSrc = useCallback(() => {
        const url = _.get(env, 'DEPLOYMENT_URL');
        return `${url}/branding/logo-header.svg`;
    }, [env]);

    const getUserName = useCallback(() => {
        let userName = auth.user_name; // oob
        if (!_.isUndefined(auth.authUserData)) {
            userName = auth.authUserData.userID;
        }
        return userName;
    }, [auth]);

    const getTitle = useCallback(() => {
        let title = auth.name; // oob
        if (!_.isUndefined(auth.authUserData)) {
            title = `${auth.authUserData.firstName} ${auth.authUserData.lastName}`;
        }
        return title;
    }, [auth]);

    const overrides = {
        applicationheader: {
            avatarProps: {
                username: getUserName(),
                title: getTitle(),
                subtitle: 'Policyholder'
            },
            avatarChildren: getAvatarLinks(),
            logoSrc: getLogoSrc(),
        },
        applicationsubheader: {
            navigationRoutes: routes
        }
    };

    const resolvers = {
        resolveClassNameMap: pageHeaderStyles,
        resolveComponentMap: {
            applicationheader: ApplicationHeader,
            subapplicationheader: SubApplicationHeader
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );
}

PageHeaderComponent.propTypes = {
    routes: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default PageHeaderComponent;
